import FuseUtils from '@fuse/utils';
import appsConfigs from 'app/main/apps/appsConfigs';
import CallbackConfig from 'app/main/callback/CallbackConfig';
import LogoutConfig from 'app/main/logout/LogoutConfig';
import { Redirect } from 'react-router-dom';
import FuseLoading from '@fuse/core/FuseLoading';
import LandingPageConfig from 'app/main/apps/urbanhive-landing-page/LandingPageConfig';

const routeConfigs = [
  ...appsConfigs,
  LogoutConfig,
  LandingPageConfig,
  CallbackConfig,
];

const routes = [
  ...FuseUtils.generateRoutesFromConfigs(routeConfigs, null),
  {
    path: '/loading',
    exact: true,
    component: () => <FuseLoading />,
  },
  {
    component: () => <Redirect to="/apps/errors/error-404" />,
  },
];

export default routes;
